import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private secretKey: string = environment.secret;
  private CPF!: string;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  addUserLocalStorageEcrypted(CPF: string) {
    let json = JSON.stringify(CPF);
    let data = CryptoJS.AES.encrypt(json, this.secretKey).toString();

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('objUser', data);
    }
  }

  addInfoLocalStorageEncrypted(key:string,obj:any){
    let json = JSON.stringify(obj);
    let data = CryptoJS.AES.encrypt(json, this.secretKey).toString();

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, data);
    }
  }

  getInfoLocalStorageDecrypt(key:string):any{
    let txtEcrypted = '';

    if (isPlatformBrowser(this.platformId)) {
      txtEcrypted = localStorage.getItem(key) ?? '';
      const bytes = CryptoJS.AES.decrypt(txtEcrypted, this.secretKey);
      const obj = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(obj);
    }
    return '';
  }



  getUserLocalStorageDecrypt(): string {
    let txtEcrypted = '';

    if (isPlatformBrowser(this.platformId)) {
      txtEcrypted = localStorage.getItem('objUser') ?? '';
      const bytes = CryptoJS.AES.decrypt(txtEcrypted, this.secretKey);
      const obj = bytes.toString(CryptoJS.enc.Utf8);
      if (obj === '') {
        this.CPF = '';
      } else {
        this.CPF = JSON.parse(obj);
      }
    }

    return this.CPF;
  }

  add(key: any, value: any) {
    if (isPlatformBrowser(this.platformId)) {
      // `setItem` converte para texto: gravar undefined/null viraria a string
      // "undefined"/"null", que passa em qualquer checagem de truthy e vira
      // "Bearer undefined" nas requisições.
      if (value === undefined || value === null) {
        console.error(`Valor inválido ao gravar "${key}" no localStorage:`, value);
        return;
      }

      localStorage.setItem(key, value);
    }
  }

  saveNumber(key: string, value: number) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value.toString());
    }
  }

  get(key: any): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    }
  }

  remove(key: any): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.removeItem(key);
    }
  }

  public clearData() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }
}
